// prod :ingredient
// rest :allitem

import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
    getItemsForRecipe,
    addRecipeIngredients,
    getRecipeDetailsByUUID,
    updateRecipeIngradients,
    getNotIngredientItemList1,
    getIsIngredientItemList1,
    getAllActiveWareRecords,
    getActiveItemRecords,
} from "../../../services/index";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SoupKitchenIcon from "@mui/icons-material/SoupKitchen";
import Button from "@mui/material/Button";
import { Spinner } from "react-bootstrap";

const RecipeNew = () => {
    const { state } = useLocation();
    const newEdit = state?.newEdit || null;
    let { id } = useParams();
    const navigate = useNavigate();
    const [isProduction, setIsProduction] = useState(true);
    const [itemOptions, setItemOptions] = useState("");
    const [itemOptions2, setItemOptions2] = useState("");
    const [requestData, setRequestData] = useState({
        title: "",
        quantity: 0,
        batchno: "",
    });
    const [notIngredientOptions, setNotIngredientOptions] = useState("");
    const [notIngredientItem, setNotIngredientItem] = useState("");
    const [itemUnit1, setItemUnit1] = useState("");
    const [loading, setLoading] = useState(false);
    const [preFilledData, setPreFilledData] = useState(false);
    const [saveBtnFlag, setSaveBtnFlag] = useState(false);
    const [itemLoading, setItemLoading] = useState(false);

    const tempRows2 = {
        step: 1,
        item: "",
        qty: 1,
        units: [
            {
                label: "",
                value: "",
            },
        ],
        selectedUnit: {
            label: "",
            value: "",
            stock: 0,
        },
        rate: 0,
        yield: 100,
        note: "",
        amount: 0,
    };

    const [rows2, setRows2] = useState([tempRows2]);
    const [total2, setTotal2] = useState(0);

    const handlAddRow2 = () => {
        setRows2([...rows2, tempRows2]);
    };

    const handleClear2 = (id, i) => {
        const obj = rows2.slice();
        obj.splice(i, 1);
        setRows2(obj);
        // handleFilterItems(obj)

        let sum = 0;
        obj.forEach((item) => {
            sum += Number(item.amount);
        });
        setTotal2(sum?.toFixed(2));

        let filterOptions = [...itemOptions];
        itemOptions2 &&
            itemOptions2.map((a) => {
                if (a.value === id) {
                    filterOptions.push(a);
                }
            });
        setItemOptions(filterOptions);
    };

    const handleStep = (e, i) => {
        const obj = [...rows2];
        obj[i].step = Number(e.target.value);
        setRows2(obj);
    };




    const handleItem = (e, i) => {
        const obj = [...rows2];
        obj[i].item = e;
        // obj[i].unit = e.weightUnitTitle;
        obj[i].units = e.units;
        obj[i].selectedUnit = e.selectedUnit;
        obj[i].rate = e.price;
        obj[i].defaultRate = e.price;
        obj[i].amount = e.selectedUnit.type === "open" ? (e.price / e.weightValue).toFixed(2) : e.price.toFixed(2);
        obj[i].weightValue = e.weightValue;
        obj[i].qty = 1;
        setRows2(obj);
        handleTotal2();
        handleFilterItems(obj);
    };

    const handleFilterItems = (rows2) => {
        var setSend = false;
        var filterOptions = [];
        itemOptions2 &&
            itemOptions2.map((a) => {
                rows2 &&
                    rows2.map((b) => {
                        if (a.value === b?.item?.value) {
                            setSend = true;
                        }
                    });
                if (!setSend) {
                    filterOptions.push(a);
                }
                setSend = false;
            });
        setItemOptions(filterOptions);
    };

    const handleQty = (e, i) => {
        const obj = [...rows2];
        obj[i].qty = Number(e.target.value);
        obj[i].amount = obj[i].selectedUnit.type === "open" ? ((obj[i].rate * obj[i].qty) / obj[i].weightValue).toFixed(2) : (obj[i].amount = (obj[i].rate * obj[i].qty).toFixed(2));
        setRows2(obj);
        handleTotal2();
    };

    const handleYield = (e, i) => {
        const obj = [...rows2];
        obj[i].yield = Number(e.target.value);
        setRows2(obj);
    };

    const handleNote = (e, i) => {
        const obj = [...rows2];
        obj[i].note = e.target.value;
        setRows2(obj);
    };

    const handleTotal2 = () => {
        let sum = 0;
        rows2 &&
            rows2.forEach((data) => {
                sum += parseFloat(data.amount);
            });
        setTotal2(sum?.toFixed(2));
    };

    useEffect(() => {
        getNotIngredientItemList1().then((res) => {
            if (res.errorCode == 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.recordId,
                    label: d.title,
                    packUnitId: d.packUnitId,
                    packUnitTitle: d.packUnitTitle,
                    sellingPriceValue: d.sellingPriceValue,
                }));
                setNotIngredientOptions(options);
            } else {
                toast.error(res.message);
            }
        });

        if (id != null) {
            getRecipeDetails(id);
        }
    }, []);

    const getRecipeDetails = (id) => {
        setItemLoading(true);
        setSaveBtnFlag(true);
        getRecipeDetailsByUUID(id).then((res) => {
            if (res.errorCode == 0) {
                let d = res.responsePacket;
                setPreFilledData(d);
                setIsProduction(d.isProduction);
                setTotal2(d.totalAmount);
                setNotIngredientItem({
                    label: res.responsePacket.itemTitle,
                    value: res.responsePacket.itemId,
                    packUnitId: res.responsePacket.quantityUnitId,
                    packUnitTitle: res.responsePacket.quantityUnitTitle,
                });
                setItemUnit1(res.responsePacket.quantityUnitTitle);
                setRequestData(res.responsePacket);
            } else {
                toast(res.message);
            }
        });
        // setItemLoading(false);
    };

    const handleQuantity = (e) => {
        setRequestData({
            ...requestData,
            quantity: e.target.value,
        });
    };

    const handleItem1 = (e) => {
        setNotIngredientItem(e);
        setItemUnit1(e.packUnitTitle);
    };

    useEffect(() => {
        if (preFilledData && preFilledData.ingredientsBeanList && itemOptions && rows2[0].item === "") {
            getSelectedItems(itemOptions);
        }
    }, [preFilledData, itemOptions]);




    // Get Pre selected requisition items
    const getSelectedItems = (options) => {
        const obj = [];
        setItemLoading(true);
        const beanList = preFilledData.ingredientsBeanList;

        for (let i = 0; i < beanList.length; i++) {
            for (let j = 0; j < options.length; j++) {
                let isOpenQty = "";

                options[j].units.map((data) => {
                    if (data.value === beanList[i].quantityUnitId) {
                        isOpenQty = data.type;
                    }
                });
                if (beanList[i].itemId === options[j].value) {
                    let itemObj = {
                        item: {
                            label: beanList[i].itemTitle,
                            value: beanList[i].itemId,
                        },
                        units: options[j].units,
                        selectedUnit: { value: beanList[i].quantityUnitId, label: beanList[i].quantityUnitTitle, type: isOpenQty },
                        rate: options[j].price,
                        // rate: beanList[i].itemRate,
                        defaultRate: beanList[i].itemRate,
                        amount:
                            isOpenQty === "open"
                                ? ((beanList[i].itemRate * beanList[i].quantity)).toFixed(2)
                                : (beanList[i].amount = (beanList[i].itemRate * beanList[i].quantity).toFixed(2)),
                        weightValue: options[j].weightValue,
                        qty: beanList[i].quantity,
                        note: beanList[i].instruction,
                        step: beanList[i].stepOrder,
                    };
                    obj.push(itemObj);
                    break;
                }
            }
        }
        if (obj.length > 0) {
            setRows2(obj);
            let total = obj.reduce((acc, e) => acc += Number(e.amount || 0), 0)
            setTotal2(total);
        }
        setItemLoading(false);
        setSaveBtnFlag(false);
    };

    useEffect(() => {
        // if (id && !preFilledData) {
        //     return;
        // }
        setRows2([tempRows2]);
        let data2 = {
            page: 0,
            search: "",
            size: -1,
            uuid: "",
        };
        // const isProductionTemp = preFilledData ? preFilledData.isProduction : isProduction;
        // if (!isProductionTemp) {
        getActiveItemRecords(data2).then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.data.map((c) => ({
                    label: c.title,
                    value: c.recordId,
                    // weightUnitId: c.weightUnitId,
                    // weightUnitTitle: c.weightUnitTitle,
                    weightValue: c.itemWeightQuantity,
                    // price: c.sellingPriceValue,
                    price: c.purchasePriceValue,
                    price: c.recipePriceValue,
                    units: [
                        { value: c.itemUnitId, label: c.itemUnitTitle, type: "open" },
                        { value: c.weightUnitId, label: c.weightUnitTitle, type: "close" },
                    ],
                    selectedUnit: { value: c.weightUnitId, label: c.weightUnitTitle, type: "close" },
                }));
                setItemOptions(options);
                setItemOptions2(options);
            }
        });
        // } else {
        //     getItemsForRecipe().then((res) => {
        //         if (res.errorCode == 0) {
        //             const options = res.responsePacket.data.map((c) => ({
        //                 label: c.title,
        //                 value: c.recordId,
        //                 // weightUnitId: c.weightUnitId,
        //                 // weightUnitTitle: c.weightUnitTitle,
        //                 weightValue: c.weightValue,
        //                 price: c.price,
        //                 units: [
        //                     { value: c.itemUnitId, label: c.itemUnitTitle, type: "open" },
        //                     { value: c.packUnitId, label: c.packUnitTitle, type: "close" },
        //                 ],
        //                 selectedUnit: { value: c.packUnitId, label: c.packUnitTitle, type: "close" },
        //             }));
        //             setItemOptions(options);
        //             setItemOptions2(options);
        //         }
        //     });
        // }
    }, [isProduction, preFilledData]);

    const handleSelectUnit = (e, i) => {
        const obj = [...rows2];
        obj[i].selectedUnit = e;
        if (e.type === "open") {
            obj[i].amount = ((obj[i].rate * obj[i].qty) / obj[i].weightValue).toFixed(2);
        } else {
            obj[i].amount = (obj[i].rate * obj[i].qty).toFixed(2);
        }
        setRows2(obj);
        handleTotal2();
    };

    const handleRateChange = (e, i) => {
        const obj = [...rows2];
        const rate = parseFloat(e.target.value);
        obj[i].rate = rate;
        if (obj[i].selectedUnit.type === "open") {
            obj[i].amount = ((rate * obj[i].qty) / obj[i].weightValue).toFixed(2);
        } else {
            obj[i].amount = (rate * obj[i].qty).toFixed(2);
        }
        setRows2(obj);
        handleTotal2();
    };

    const handleSave = () => {
        setLoading(true);

        if (!notIngredientItem.value || notIngredientItem.value === "") {
            toast("Please select Recipe");
            setLoading(false);
            return;
        }

        let arr1 = [];
        let filteredList = rows2.filter((data) => data.item.value);

        for (let i = 0; i < filteredList.length; i++) {
            const d = filteredList[i];
            if (!d.rate || d.rate === 0 || d.rate === "0" || d.rate === "") {
                toast(`Please provide Rate for ${d.item.label}`);
                setLoading(false);
                return;
            }
            let data = {
                itemId: d.item.value,
                itemTitle: d.item.label,
                quantityUnitId: d.selectedUnit.value,
                quantityUnitTitle: d.selectedUnit.label,
                instruction: d.note,
                quantity: d.qty,
                stepOrder: d.step,
                itemRate: d.rate,
                recipePriceValue: d.rate,
                yield: 100,
                itemWeightValue: d.weightValue,
                amount: Number(d.amount),
                // yield: d.yield,
            };
            arr1.push(data);
        }

        filteredList.map((d) => { });

        let request = {
            batchNo: "BA",
            itemId: notIngredientItem.value,
            itemTitle: notIngredientItem.label,
            quantityUnitId: notIngredientItem.packUnitId,
            quantityUnitTitle: notIngredientItem.packUnitTitle,
            ingredientsBeanList: arr1,
            totalAmount: total2,
            quantity: parseFloat(requestData.quantity),
            isProduction: isProduction,
        };

        if (id != null && newEdit !== "true") {
            updateRecipeIngradients(id, request)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast(res.message);
                        navigate("/recipe");
                        setLoading(false);
                    } else {
                        toast(res.message);
                        setLoading(false);
                        return;
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        } else {
            addRecipeIngredients(request)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast(res.message);
                        setLoading(false);
                        navigate("/recipe");
                    } else {
                        toast(res.message);
                        setLoading(false);
                        return;
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        }
    };

    return (
        <>
            <div className="fill list-header d-flex  align-items-center bg-white p-3 border-bottom">
                <SoupKitchenIcon /> {id && newEdit !== "true" ? "Edit" : "New"} Recipe
            </div>

            <div className="scroll-y noscroll-x fill body scrollbox" style={{ marginLeft: "20px" }}>
                <div className="item-creation" autoComplete="off">
                    <div className="primary-info white-bg">
                        <div className="item-new">
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="d-flex mb-3" >
                                        <div className="mr-5">
                                            <input
                                                type="radio"
                                                className="pb-3 mr-2"
                                                name="isProduction"
                                                id="isProductionT"
                                                disabled={id && newEdit !== "true" ? true : false}
                                                checked={isProduction}
                                                onChange={(e) => setIsProduction(e.target.value)}
                                            />
                                            <label htmlFor="isProductionT">Production</label>
                                        </div>
                                        <div className="">
                                            <input
                                                type="radio"
                                                className="pb-3 mr-2"
                                                name="isProduction"
                                                id="isProductionF"
                                                disabled={id ? true : false}
                                                checked={!isProduction}
                                                onChange={(e) => setIsProduction(!e.target.value)}
                                            />
                                            <label htmlFor="isProductionF">Restaurant</label>
                                        </div>
                                    </div>

                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">Select Recipe</label>
                                        <div className="col-lg-5">{notIngredientOptions && <Select onChange={(e) => handleItem1(e)} options={notIngredientOptions} value={notIngredientItem} />}</div>
                                    </div>

                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">Batch Size</label>
                                        <div className="col-lg-5">
                                            <input autoComplete="off" value={requestData.quantity} className="form-control" name="quantity" onChange={(e) => handleQuantity(e)} type="number" min="0" />
                                        </div>
                                    </div>

                                    <div className="row ">
                                        <label className="col-lg-3  required">Unit</label>
                                        <div className="col-lg-5">
                                            <input autoComplete="off" className="form-control" disabled={true} value={itemUnit1} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <hr />
                        <div className="customTable">
                            <table>
                                <thead>
                                    <tr>
                                        <td></td>
                                        <td>Step</td>
                                        <td>Item</td>
                                        <td>Qty</td>
                                        <td>Unit</td>
                                        <td>Rate</td>
                                        {/* <td>Yield%</td> */}
                                        <td>Instruction</td>
                                        <td>Amount</td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows2.map((data, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>
                                                    <div className={itemLoading ? "spinner-loader" : ""}></div>
                                                </td>
                                                <td>
                                                    <input autoComplete="off" type="number" min={1} value={data.step} onChange={(e) => handleStep(e, i)} />
                                                </td>
                                                <td style={{ width: "250px" }}>
                                                    <Select
                                                        isDisabled={!itemOptions || itemOptions === undefined || itemOptions === ""}
                                                        style={{ zIndex: "20" }}
                                                        placeholder="Ingredients"
                                                        options={itemOptions}
                                                        value={data.item}
                                                        onChange={(e) => handleItem(e, i)}
                                                    />
                                                </td>
                                                <td>
                                                    <input autoComplete="off" type="number" min={1} value={data.qty} onChange={(e) => handleQty(e, i)} className="mr-2" />
                                                    {/* {data.unit} */}
                                                </td>
                                                <td>
                                                    <Select value={data.selectedUnit} options={data.units} onChange={(e) => handleSelectUnit(e, i)} />
                                                </td>
                                                <td style={{ width: "150px" }}>
                                                    <input
                                                        autoComplete="off"
                                                        type="number"
                                                        disabled={data.defaultRate !== 0}
                                                        value={data.rate}
                                                        onChange={(e) => handleRateChange(e, i)}
                                                        style={{ minWidth: "140px" }}
                                                    />
                                                </td>
                                                {/* <td>
                                                <input autoComplete="off" type="number" value={data.yield} onChange={(e) => handleYield(e, i)} />
                                            </td> */}
                                                <td>
                                                    <input autoComplete="off" type="textarea" value={data.note} onChange={(e) => handleNote(e, i)} />
                                                </td>
                                                <td>
                                                    <input autoComplete="off" style={{ width: "150px" }} type="number" disabled={true} value={data.amount} />
                                                </td>

                                                <td style={{ cursor: "pointer" }} onClick={() => handleClear2(data.item.value, i)}>
                                                    {rows2.length > 1 && <i className="fa fa-times"></i>}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td className="font-large text-uppercase font-xs text-open">Total: ₹ {total2}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <button id="ember1426" className="btn btn-default addbtn mt-3" onClick={handlAddRow2}>
                            <AddIcon style={{ color: "blue" }} /> New Row
                        </button>
                        <div className="text-left mt-3 mb-4">
                            {loading ? (
                                <Button variant="contained">
                                    <Spinner />
                                </Button>
                            ) : (
                                <Button variant="contained" onClick={handleSave} disabled={saveBtnFlag}>
                                    Save
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Toaster />
        </>
    );
};

export default RecipeNew;
